import {
  CarteiraSelecaoModel,
  ValidacaoSelecaoModel,
} from "./selecao-carteira/carteira-selecao-model";
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";

import {Associacao} from "./associacao";
import {AssociacaoModule} from "../associacao.module";
import {AutocompleteItem} from "../../shared/models/autocomplete.model";
import {Carteira} from "../../carteira/carteira.model";
import {DatePipe} from "@angular/common";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RegraSelecaoModel} from "../../regra/selecao-regras/regra-selecao-model";
import {catchError} from "rxjs/operators";
import {handleError} from "../../shared/util/error-util";
import { CarteiraAutocompleteMapper } from "src/app/shared/components/carteira-autocomplete/carteira-autocomplete.mapper";

@Injectable({
  providedIn: "root",
})
export class AssociacaoService {
  private readonly url = "/v1/carteira/regra/associacoes";

  private readonly regras: RegraSelecaoModel[];

  private readonly carteiras: CarteiraSelecaoModel[];

  private readonly _contentType = "application/json";

  private readonly headers = new HttpHeaders({"Content-Type": this._contentType});

  private validacaoSelecaoModels: ValidacaoSelecaoModel[];

  paginationTotalPage = 1;

  constructor(private readonly http: HttpClient, private readonly datePipe: DatePipe, private readonly carteiraAutocompleteMapper: CarteiraAutocompleteMapper) {
    this.regras = [];
    this.carteiras = [];
    this.validacaoSelecaoModels = [];
  }

  addRegra(value: AutocompleteItem) {
    this.validacaoSelecaoModels = [];
    let podeAdd = true;
    let itemNaoVazio = true;
    for (const regras of this.regras) {
      if (regras.id === value.id) {
        podeAdd = false;
      }
    }
    if (value === null || value.name === null) {
      itemNaoVazio = false;
    }
    if (podeAdd && itemNaoVazio) {
      const regraSelecaoModel = new RegraSelecaoModel();
      regraSelecaoModel.nome = value.name;
      regraSelecaoModel.id = value.id;
      this.regras.push(regraSelecaoModel);
      this.regras.sort(this.compareNome);
      this.calcularSelecaoModel();
    }
    return podeAdd;
  }

  compareNome(a: any, b: any) {
    if (a.nome < b.nome) {
      return -1;
    }
    if (a.nome > b.nome) {
      return 1;
    }
    return 0;
  }

  addCarteira(value: Carteira, carteiras: Carteira[]) {
    if (!value || (value.name !== null && carteiras.includes(value))) {
      return false;
    }

    carteiras.push(value);
    carteiras.sort(this.compareNome);

    return true;
  }


  getRegras(page: any) {
    const regras: RegraSelecaoModel[] = [];
    const start = page * 10 - 10;
    for (let i = start; i < page * 10 && i < this.regras.length; i++) {
      regras.push(this.regras[i]);
    }
    return regras;
  }

  getCarteiras(page: number, carteiras: Carteira[]) {
    const carteirasModel: CarteiraSelecaoModel[] = [];
    const start = page * 10 - 10;
    for (let i = start; i < page * 10 && i < carteiras.length; i++) {
      carteirasModel.push(this.carteiras[i]);
    }
    return carteirasModel;
  }

  getAssociacaoPaginado(page: number) {
    const associacao = this.getAssociacao();
    const associacaoPagnating: ValidacaoSelecaoModel[] = [];
    const start = page * 10 - 10;
    for (let i = start; i < page * 10 && i < associacao.length; i++) {
      associacaoPagnating.push(associacao[i]);
    }
    associacaoPagnating.sort(this.compareAssociacao);
    return associacaoPagnating;
  }

  compareAssociacao(a: ValidacaoSelecaoModel, b: ValidacaoSelecaoModel) {
    if (a.carteiraNome < b.carteiraNome) {
      return -1;
    }
    if (a.carteiraNome > b.carteiraNome) {
      return 1;
    }
    if (a.regraNome < b.regraNome) {
      return -1;
    }
    if (a.regraNome > b.regraNome) {
      return 1;
    }
    return 0;
  }

  removerCarteira(s: any, carteiras: Carteira[]) {
    const index = carteiras.findIndex((i) => i.id === s.id);
    if (index >= 0) {
      this.removerAssociacaoParaCarteira(s);
      return carteiras.splice(index, 1);
    }
    this.calcularSelecaoModel();
    return carteiras;
  }

  removerRegra(s: any) {
    const index = this.regras.findIndex((i) => i.id === s.id);
    if (index >= 0) {
      this.removerAssociacaoParaRegra(s);
      return this.regras.splice(index, 1);
    }
    this.calcularSelecaoModel();
    return this.regras;
  }

  getAssociacao() {
    if (this.validacaoSelecaoModels.length === 0) {
      this.calcularSelecaoModel();
    }
    return this.validacaoSelecaoModels;
  }

  calcularSelecaoModel() {
    for (const carteira of this.carteiras) {
      for (const regra of this.regras) {
        const validacaoSelecaoModel = new ValidacaoSelecaoModel();
        validacaoSelecaoModel.carteiraNome = carteira.nome;
        validacaoSelecaoModel.regraNome = regra.nome;
        this.validacaoSelecaoModels.push(validacaoSelecaoModel);
      }
    }
  }

  associar(validacaoSelecaoModels: ValidacaoSelecaoModel[], carteiras: Carteira[]) {
    const associacoes: AssociacaoModule[] = [];
    for (const validacaoSelecaoModel of validacaoSelecaoModels) {
      const associacao: Associacao = new Associacao();
      associacao.carteiraId = validacaoSelecaoModel.carteiraId;
      associacao.regraId = validacaoSelecaoModel.regraId;
      associacao.inicio = validacaoSelecaoModel.dataInicioAssociacao;
      associacao.processamentoOnlineAtivo = validacaoSelecaoModel.processamentoOnlineAtivo;
      associacoes.push(associacao);
    }
    const headers = this.headers;
    return this.http.post<any>(`${this.url}`, associacoes, {headers}).pipe();
  }


  editarAssociacao(carteira: string, regra: string, associacao: any) {
    const headers = new HttpHeaders({"Content-Type": "application/merge-patch+json"});

    const params = new HttpParams()
      .set("carteira", carteira)
      .set("regra", regra)
    // httpclient substitui + com espaço
    return this.http.patch<any>(`${this.url}?${params.toString().replace(/\+/gi, '%2B')}`, associacao, {headers});
  }

  isDisabled() {
    return (
      (this.regras.length === 0 &&
        this.carteiras.length === 0 &&
        this.validacaoSelecaoModels.length === 0) ||
      this.dataAndPosFatoMarcado()
    );
  }

  private dataAndPosFatoMarcado() {
    let isOneDataAndPosFatoNaoMarcado =
      this.validacaoSelecaoModels.length === 0;
    for (const validacaoSelecaoModel of this.validacaoSelecaoModels) {
      if (
        validacaoSelecaoModel.processamentoOnlineAtivo == null ||
        validacaoSelecaoModel.dataInicioAssociacao == null
      ) {
        isOneDataAndPosFatoNaoMarcado = true;
      }
    }
    return isOneDataAndPosFatoNaoMarcado;
  }

  getPage() {
    const number = Math.ceil(this.getAssociacao().length / 10);
    if (number === 0) {
      return 1;
    }
    return number;
  }

  getCarteiraPage() {
    const number = Math.ceil(this.carteiras.length / 10);
    if (number === 0) {
      return 1;
    }
    return number;
  }

  getRegrasTotalPage() {
    const number = Math.ceil(this.regras.length / 10);
    if (number === 0) {
      return 1;
    }
    return number;
  }

  private removerAssociacaoParaCarteira(s: CarteiraSelecaoModel) {
    while (this.aindaContemCarteira(s)) {
      const index = this.validacaoSelecaoModels.findIndex(
        (i) => i.carteiraNome === s.nome
      );
      if (index >= 0) {
        this.validacaoSelecaoModels.splice(index, 1);
      }
    }
  }

  private aindaContemCarteira(s: any) {
    return (
      this.validacaoSelecaoModels.findIndex(
        (i) => i.carteiraNome === s.nome
      ) !== -1
    );
  }

  private removerAssociacaoParaRegra(s: any) {
    while (this.aindaContemRegra(s)) {
      const index = this.validacaoSelecaoModels.findIndex(
        (i) => i.regraNome === s.nome
      );
      if (index >= 0) {
        this.validacaoSelecaoModels.splice(index, 1);
      }
    }
  }

  private aindaContemRegra(s: any) {
    return (
      this.validacaoSelecaoModels.findIndex((i) => i.regraNome === s.nome) !==
      -1
    );
  }

  marcaAssociacao(value: any) {
    const dataInicioAssociacao = value.dataInicioAssociacao;
    for (const validacaoSelecaoModel of this.getAssociacao()) {
      validacaoSelecaoModel.processamentoOnlineAtivo = value.processamentoOnlineAtivo;
      if (dataInicioAssociacao !== null) {
        validacaoSelecaoModel.dataInicioAssociacao = dataInicioAssociacao;
      }
    }
  }

  search(value: any, pageSize: number): Observable<any> {
    const headers = this.headers;
    let params = this.createFormParam(value);

    const size = pageSize.toString();
    params = params.set("size", size);
    params = params.set("page", value.page);

    const options = {headers, params};
    return this.http
      .get<any[]>(`${this.url}/all`, options)
      .pipe(catchError(handleError));
  }

  notNullNotEmpty(value: any): boolean {
    return value !== null && value !== "";
  }

  excluirAssociacao(id: string) {
    const headers = this.headers;
    let params: HttpParams = new HttpParams();
    params = params.set("id", id);
    const options = {headers, params};
    return this.http
      .delete(`${this.url}`, options)
      .pipe(catchError(handleError));
  }

  exportPdf(value: any): Observable<HttpResponse<Blob>> {
    const headers = this.headers;
    const params = this.createFormParam(value).set("size", '99999999');
    return this.http.get(`${this.url}/export/pdf`, {
      headers,
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }

  exportXlsx(value: any): Observable<HttpResponse<Blob>> {
    const headers = this.headers;
    const params = this.createFormParam(value).set("size", '99999999');
    return this.http.get(`${this.url}/export/xlsx`, {
      headers,
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }


  private createFormParam(value: any) {

    let params: HttpParams = new HttpParams();
    this.carteiraAutocompleteMapper.map(value);

    if (this.notNullNotEmpty(value.regra)) {
      params = params.set("regraId", value.regra);
    }

    if (this.notNullNotEmpty(value.carteiraId)) {
      params = params.set("carteiraId", value.carteiraId);
    }

    if (value.grupoCarteiraId && this.notNullNotEmpty(value.grupoCarteiraId)) {
      params = params.set("grupoCarteiraId", value.grupoCarteiraId);
    }

    if (this.notNullNotEmpty(value.dataInicio)) {
      params = params.set(
        "inicio",
        this.datePipe.transform(value.dataInicio, "yyyy-MM-dd")
      );
    }

    if (this.notNullNotEmpty(value.dataFim)) {
      params = params.set(
        "fim",
        this.datePipe.transform(value.dataFim, "yyyy-MM-dd")
      );
    }

    if (this.notNullNotEmpty(value.tipoExecucao)) {
      if (value.tipoExecucao.id === "POS_FATO") {
        params = params.set("processamentoOnlineAtivo", "false");
      } else {
        params = params.set("processamentoOnlineAtivo", "true");
      }
    }
    params = params.set("sort", "carteira.nome,regra.nome,processamentoOnlineAtivo,ASC");

    return params;
  }
  downloadModelo(): Observable<HttpResponse<Blob>> {
    return this.getExportDataFrom(`${this.url}/download-modelo`);
  }

  private getExportDataFrom(path: string): Observable<HttpResponse<Blob>> {
    const params = new HttpParams();
    return this.http.get(path, {
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }
}
